import { DataListViewTemplateSlots, SlotSelectors } from '../models';

export const slotSelectors: SlotSelectors = {
  [DataListViewTemplateSlots.ToolbarActions]: `[slot='${DataListViewTemplateSlots.ToolbarActions}']`,
} as const;
